<div class="transportation" *ngIf="showTransportDetails">
  <div *ngIf="showBusRoutesDetails">
    <p (click)="showModalDetails(busRouteDetails)">Bus Routes</p>
  </div>
  <div *ngIf="showParkingInfoDetails">
    <p (click)="showModalDetails(parkingDetails)">Parking</p>
  </div>
  <div *ngIf="showDirectionsDetails">
    <p (click)="showModalDetails(directionsDetails)">Directions</p>
  </div>
</div>
<div [ngClass]="{'fal-fal-modal':isChart}">
  <fal-fal-modal [events]="loadTransportDetails.asObservable()"></fal-fal-modal>
</div>